export default class FilterComponent extends HTMLElement {
    private _dropdown: HTMLElement;
    private _dropdownAction: HTMLButtonElement;

    constructor() {
        super();
        this._dropdown = this.querySelector('[data-name="dropdown"]');
        this._dropdownAction = this.querySelector('[data-name="open-dropdown"]');
    }

    private handleToggleDropdown = (e: Event) => {
        e.preventDefault();
        const isOpen = this.classList.contains('is-dropdown-open');

        if (!isOpen) {
            this.openDropdownLink(this);
        } else {
            this.closeDropdownLink(this);
        }
    }
    private handleTabFocus = (e: KeyboardEvent) => {
        let isTabPressed = e.key === 'Tab';
        const lastElement = this._dropdown.lastElementChild;
        const firstElement = this._dropdown.firstChild;

        if (document.activeElement === lastElement.firstChild){ 
            if(!isTabPressed) {
                return;
            }
            else if(e.shiftKey && isTabPressed) {
                return;
            }
            else if(isTabPressed) {
                this.closeDropdownLink(this);
            }
        }
        else if (document.activeElement === firstElement.firstChild) {
            if(!isTabPressed) {
                return;
            }
            else if(e.shiftKey && isTabPressed) {
                this.closeDropdownLink(this);
            }
        }
    }

    private handleNavBarShiftTab = (e: KeyboardEvent) => {
        let isTabPressed = e.key === 'Tab';

        if(this._dropdownAction === document.activeElement) {
            if(e.shiftKey && isTabPressed) {
                this.closeDropdownLink(this);
            }
        }
       
    }

    private openDropdownLink = (dropdownLink: HTMLElement) => {
        dropdownLink.classList.add('is-dropdown-open');
        dropdownLink.classList.remove('is-dropdown-closed');
        let newHeight = 0;
        for (let i = 0; i < this._dropdown.children.length; i++) {
            const dropdownItem = this._dropdown.children[i] as HTMLLIElement;
            dropdownItem.style.height = `${dropdownItem.scrollHeight}px`;
            newHeight += dropdownItem.scrollHeight;
        }
        this._dropdown.style.height = `${newHeight}px`;
        this._dropdown.setAttribute('aria-expanded', 'true');
        window.addEventListener("click", this.handleClickOutsideComponent);
        window.addEventListener("keydown", this.handleEscExpandedClose);
    }

    private closeDropdownLink = (dropdownLink: HTMLElement) => {
        dropdownLink.classList.remove('is-dropdown-open');
        dropdownLink.classList.add('is-dropdown-closed');
        this._dropdown.style.height = '0';
        this._dropdown.setAttribute('aria-expanded', 'false');
        for (let i = 0; i < this._dropdown.children.length; i++) {
            (this._dropdown.children[i] as HTMLElement).style.height = '0';
        }
        window.removeEventListener("click", this.handleClickOutsideComponent);
    }
    private handleEscExpandedClose = (e: KeyboardEvent) => {
        let isEscPressed = e.key === 'Escape';
        if (!isEscPressed) return;
        this.closeDropdownLink(this);
        window.removeEventListener("keydown", this.handleEscExpandedClose);
    }

    private handleClickOutsideComponent: EventListener = (e: Event): void => {
        const target = e.target as Node;
        const isClickOutside = !this.contains(target);
        if (isClickOutside) {
            this.closeDropdownLink(this);
            window.removeEventListener("click", this.handleClickOutsideComponent);
        }
    }
    private isInViewPort = () => {
        const dropDownNav = this._dropdown.getBoundingClientRect();
        const screenWidth = (document.documentElement.clientWidth - 25);
       
        if(dropDownNav.right >= (window.innerWidth || document.documentElement.clientWidth)) {
            this._dropdown.style.left=`${(screenWidth - dropDownNav.right)}px`;
        } 
    }
   

    connectedCallback() {
        this._dropdownAction.addEventListener('click', this.handleToggleDropdown);
        this._dropdownAction.addEventListener('click', this.handleToggleDropdown, false);
        this._dropdown.addEventListener("keydown", this.handleTabFocus);
        this._dropdownAction.addEventListener('keydown', this.handleNavBarShiftTab, false);
        this.isInViewPort();
        window.addEventListener('resize', this.isInViewPort);
    }
}